<div class="timeline-container" #timeline id="planning-gantt" (wheel)="onMouseWheel($event)"
  [style.--periods-height.px]="periodHeight()">
  <div class="tree" [style.top]="scrollTop * -1 + 'px'" [style.width]="treeWidth + 'px'"
    [style.height]="graphHeight + 'px'">
    <ng-container *ngFor="let line of filteredTasks; let index = index;" id="tree-tasks">
      <div class="drop-line" *ngIf="showDropLine && index === hoverIndex"></div>

      <div *ngIf="line.children" class="tree-child {{line.children.length ? 'parent' : 'leaf'}}" [ngClass]="{ 
  'dragged': isDragged(index),
  'drop-before': hoverIndex === index && dropZoneState === 'before',
  'drop-after': hoverIndex === index && dropZoneState === 'after',
  'drop-child': hoverIndex === index && (dropZoneState === 'child-start' || dropZoneState === 'child-end')
}" [style.backgroundColor]="line.backgroundColor" [id]="'task-'+ index" draggable="true"
        [draggable]="isDragEnabled && draggedTaskIndex === index" (dragstart)="onDragStart($event, index)"
        (dragend)="onDragEnd($event)" (dragover)="onDragOver($event, index)" (dragleave)="onDragLeave()"
        (drop)="onDrop($event, index)" (click)="onLineClick(line)">

        <div class="drop-zone-before" *ngIf="dropZoneState === 'before' && hoverIndex === index">
          <mat-icon fontIcon="arrow_upward"></mat-icon>
          {{"planning.before" | translate}}
        </div>

        <div class="drop-zone-after" *ngIf="dropZoneState === 'after' && hoverIndex === index">
          <mat-icon fontIcon="arrow_downward"></mat-icon>
          {{"planning.after" | translate}}
        </div>

        <div class="drop-zone-child"
          *ngIf="(dropZoneState === 'child-start' || dropZoneState === 'child-end') && hoverIndex === index">
          <mat-icon fontIcon="arrow_rightward"></mat-icon>
          {{"planning.child" | translate}}
        </div>

        <div class="drag-handle" (mousedown)="startDrag($event, index); $event.stopPropagation()"
          (mouseup)="stopDrag(); $event.stopPropagation()">
          <mat-icon svgIcon="drag_box"></mat-icon>
        </div>

        <div class="flex">
          <div class="tree-child-name" [style.paddingLeft]="(line.indent || 0) * 7 + 'px'">
            <strong *ngIf="line.children.length">
              <div class="line-number" [ngClass]="'status-' + line.priority">{{line.number}}</div>
              {{line.text}}
            </strong>

            <span *ngIf="!line.children.length">
              <div class="line-number" [ngClass]="'status-' + line.priority">{{line.number}}</div>
              {{line.text}}
            </span>
          </div>
        </div>

        <div class="right-btn">
          <button class="metric-chip" [class.loading]="line.metrics === undefined"
            (click)="selectMetrics(line); $event.stopPropagation()" matTooltip="{{'planning.metrics' | translate}}">
            <ng-container *ngIf="line.metrics !== undefined">
              <mat-icon>event</mat-icon>
              {{line.metrics.length}}
            </ng-container>

            <app-spinner *ngIf="line.metrics === undefined" [diameter]="10" color="primary" iconOnly></app-spinner>
          </button>

          <button class="metric-chip" [class.loading]="line.fragments === undefined"
            (click)="selectFragments(line); $event.stopPropagation()" matTooltip="{{'planning.fragments' | translate}}">
            <ng-container *ngIf="line.fragments !== undefined">
              <mat-icon>place</mat-icon>
              {{line.fragments.length}}
            </ng-container>

            <app-spinner *ngIf="line.fragments === undefined" [diameter]="10" color="primary" iconOnly></app-spinner>
          </button>

          <div class="add-task">
            <mat-icon class="icon" (click)="addTask(index); $event.stopPropagation()">add</mat-icon>
          </div>
        </div>

        <div class="arrows" *ngIf="line.hasChildren">
          <div class="arrow-down" *ngIf="line.open" (click)="closeLine('metric', line); $event.stopPropagation()"></div>
          <div class="arrow-left" *ngIf="!line.open" (click)="openLine('metric', line); $event.stopPropagation()"></div>
        </div>
      </div>
    </ng-container>

    <div class="tree-bottom">
      <div class="group">
        <!-- <button mat-icon-button (click)="setZoom(1)">
                    <mat-icon>zoom_out</mat-icon>
                </button>
                <button mat-icon-button (click)="setZoom(-1)">
                    <mat-icon>zoom_in</mat-icon>
                </button> -->
      </div>
    </div>
  </div>

  <div *ngIf="showGantt" class="board" id="timeline-board" #board [style.left]="treeWidth + 'px'"
    [style.width]="boardWidth + 'px'">
    <div *ngIf="filteredTasks.length !== 0" class="resize-bar" id="resizeBar"></div>

    <div class="graph-container" id="graph-container" [style.width]="graphWidth + 'px'"
      [style.transform]="'translateX(' + -scrollLeft + 'px)'" #graph>

      <div *ngFor="let m of months; let i = index;" [style.left]="m.position + 4 + 'px'"
        [style.height]="graphHeight + 'px'" class="vertical">
      </div>

      <div *ngFor="let w of weeks; let i = index;" [style.left]="w.position + 4 + 'px'"
        [style.height]="graphHeight + 'px'" [style.width]="daySize * 2 + 'px'" class="vertical week">
      </div>

      <div *ngFor="let d of days; let i = index;" [style.left]="d.position + 4 +'px'"
        [style.height]="graphHeight + 'px'" class="vertical day">
      </div>

      <div *ngFor="let h of hours; let i = index;" [style.left]="h.position   + 'px'"
        [style.height]="graphHeight + 'px'" class="vertical hour">
      </div>

      <!-- <div *ngFor="let m of minutes; let i = index;" [style.left]="m.position * hourSize * scale + 'px'"
        [style.height]="graphHeight + 'px'" class="vertical">
      </div> -->

      <div class="lines-container">
        <ng-container *ngFor="let line of filteredTasks;let index = index; trackBy: trackByTaskFn">
          <div *ngIf="!line.hidden" class="line {{line.children && line.children.length ? 'parent' : ''}}"
            [style.backgroundColor]="line.backgroundColor">

            <div class="graph-task" [style.left]="getScaled(line.left || 0)+ 'px'" (mouseleave)="onMouseLeaveBar()"
              (mouseenter)="onMouseEnterBar($event, line, 0)">
              <div class="graph-bar {{currentScale}}" [style.width]="getScaled(line.width || 0) + 'px'"
                [style.background]="line.color">
                <div class="line-label">{{line.text}}</div>
              </div>
            </div>

            <div class="graph-detection" [style.left]="getScaled(line.firstUpdateLeft || 0) + 'px'"
              (mouseleave)="onMouseLeaveBar()" (mouseenter)="onMouseEnterBar($event, line, 0)">
              <div class="graph-bar {{currentScale}}" [style.width]="getScaled(line.firstUpdateWidth || 0) + 'px'">
                <div class="line-label">{{line.text}}</div>
              </div>
            </div>

            <div *ngIf="(line.lateWidth || 0) > 0" class="graph-late-bar"
              [style.left]="getScaled((line.left || 0) + (line.width || 0))+ 'px'" (mouseleave)="onMouseLeaveBar()"
              (mouseenter)="onMouseEnterBar($event, line, 0)">
              <div class="graph-bar {{currentScale}}" [style.width]="getScaled(line.lateWidth || 0)-2 + 'px'">
                <div class="line-label">{{line.text}}</div>
              </div>
            </div>

            @if(scaleIndex > 6){
            <div *ngFor="let m of line.metrics;let _index = index; trackBy: trackByMetricFn" class="graph-metric"
              [style.left]="getScaled(m.left)+ 'px'" (mouseleave)="onMouseLeaveBar()"
              (mouseenter)="onMouseEnterBar($event, line, _index)">
              <div class="graph-bar {{currentScale}}" [style.width]="getScaled(m.width) + 'px'"
                [style.background]="m.color">
                <div class="line-label">{{m.label}}</div>
              </div>
            </div>
            }
          </div>
        </ng-container>
      </div>

      <div id="date-bar" class="date-bar" [style.left]="dateBarLeft + 'px'" [style.height]="graphHeight + 'px'"></div>
    </div>

    <div class="periods-wrapper" [style.width]="'100%'" [ngClass]="{'year-only': isGreaterThan('year')}">
      <div class="periods-header" [style.left]="(scrollLeft) * -1 + 'px'">

        <!-- Années -->
        <ng-container *ngIf="state().showYears">
          <div *ngFor="let year of years; let index; trackBy: trackByFn" class="period periode-year"
            (click)="onZoom('year', year)" [style.width]="year.size + 'px'" [style.left]="(year.position) + 'px'">
            <div class="label">{{year.label}}</div>
          </div>
        </ng-container>

        <!-- Mois -->
        <ng-container *ngIf="state().showMonths">
          <div *ngFor="let month of months; let index; trackBy: trackByFn" class="period periode-month"
            (click)="onZoom('month', month)" [style.width]="month.size  + 'px'" [style.left]="month.position  + 'px'">
            <div class="label">{{month.label}}</div>
          </div>
        </ng-container>

        <!-- Semaines -->
        <ng-container *ngIf="state().showWeeks">
          <div *ngFor="let week of weeks; let index; trackBy: trackByFn" class="period periode-week "
            (click)="onZoom('week', week)" [style.width]="week.size + 'px'" [style.left]="(week.position) + 'px'">
            <div class="label">{{week.label}}</div>
          </div>
        </ng-container>

        <!-- Jours -->
        <ng-container *ngIf="state().showDays">
          <div *ngFor="let day of days; let index; trackBy: trackByFn" class="period periode-day"
            [style.width]="24 * hourSize + 'px'" [style.left]="day.position + 'px'">
            <div class="label">{{day.label}}</div>
          </div>
        </ng-container>

        <!-- Heures -->
        <ng-container *ngIf="state().showHours">
          <div *ngFor="let hour of hours; let index;" class="period periode-hour "
            [style.width]="hourSize * scale + 'px'" [style.left]="hour.position + 'px'">
            <div class="label">{{hour.label}}</div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<div *ngIf="filteredTasks.length === 0" class="no-data">
  <lib-no-data message="planning.noData.noTasks" description="planning.noData.noTasks_desc" icon="search_off">
    <lib-button (click)="addTask()" icon="add" text="{{'planning.addTask' | translate}}"></lib-button>
  </lib-no-data>
</div>